<template>
    <div>
        <div class="pm-right-sidebar mb-2 mt-2 p-3">
            <h2 class="mb-0"> Payroll Processed </h2>
            <!-- <span class="highlight-color d-block mb-3"> Most Recent Payroll {{payroll_processed[0].created_at  | date_format}} </span> -->

            <p> Previous Payroll </p>
            <select class="selectpicker custom-select2">
                <option v-for="batch in payroll_processed" v-bind:value="batch.id" v-bind:key="batch.id">
                    {{batch.created_at  | date_format}} - {{batch.net_salary}}
                </option>
            </select>
            <button>View Payroll</button>
        </div>
    </div>
</template>

<script>
    export default {
        props:['payroll_processed'],
        data() {
            return {
            }
        },

        created() {
        }
    }
</script>
